export default "__VITE_ASSET__f26961a6__"